import * as joint from '@clientio/rappid'

export default class ExpandButton extends joint.elementTools.Button {
  constructor(private runnable: (cellView: joint.dia.ElementView) => void) {
    super({
      markup: [
        {
          tagName: 'circle',
          selector: 'button',
          attributes: {
            r: 14,
            fill: 'rgba(1, 1, 1, .25)',
            stroke: 'rgba(0, 0, 0, 0.5)',
            'stroke-width': 2,
            cursor: 'pointer',
          },
        },
        {
          tagName: 'path',
          selector: 'icon',
          attributes: {
            d: 'M7,10L12,15L17,10H7Z',
            fill: 'black',
            transform: 'translate(-12 -12)',
          },
        },
      ],
      x: '95%',
      y: 0,
      offset: {
        x: 0,
        y: 20,
      },
      rotate: true,
      action: function (evt: any, cellView: joint.dia.ElementView) {
        if (runnable) {
          runnable(cellView)
          //define action which could be executed when clicking ont he expand Button
        }
      },
    })
  }
}
